// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1ChPz","legacyBtn":"MutateMid_legacyBtn__VGW9V"};